module.exports = __webpack_public_path__ + "img/service-consulting-1.cc5efa4f.jpg";